export default __webpack_public_path__ + "static/media/Logo_Complete_White.6278c5de.png";